export const shortenEmail = (email?: string, keep: number = 7): string => {
    if (!email || typeof email !== 'string') return '';
    const atIndex = email.indexOf('@');
    if (atIndex <= 0) return email;

    const local = email.slice(0, atIndex);
    const domain = email.slice(atIndex + 1);
    const visible = local.slice(0, Math.min(keep, local.length));
    return `${visible}****@${domain}`;
};


